import { availableLanguages } from 'utils/i18n'
import { HELPER_LINKS_URIS } from './constants'
import { ILangsAvailable } from 'utils/interface'
import { ILinksItem } from './interface'
import { TFunction } from 'i18next'

export const getHelperLinks = (langCode: string, t: TFunction, tRoot: string): Array<ILinksItem> => [
  {
    link: HELPER_LINKS_URIS.goToHome,
    target: '_self',
    text: t(`${tRoot}.goToHome`)
  },
  {
    link: HELPER_LINKS_URIS.devCenter,
    target: '_blank',
    text: t(`${tRoot}.devCenter`)
  },
  {
    link: `${HELPER_LINKS_URIS.helpCenter}${langCode}`,
    target: '_blank',
    text: t(`${tRoot}.helpCenter`)
  }
]

export const getLangCode = (langCodeSelected = ''): string => {
  const LANG_CODE_DEFAULT = availableLanguages().find((language: ILangsAvailable) => language.default)

  if (!!LANG_CODE_DEFAULT && langCodeSelected === LANG_CODE_DEFAULT.value) {
    // "419" comes from https://help.conekta.com/hc/es-419 (Spanish L10n)
    return `${langCodeSelected}-419`
  }

  return langCodeSelected
}
